// extracted by mini-css-extract-plugin
module.exports = {"list":"social-link-list_list__UkSo2"};